// extracted by mini-css-extract-plugin
module.exports = {"Container":"FooterDown_Container__Z_6UK","Short":"FooterDown_Short__0eGEE","Info":"FooterDown_Info__YZi2Q","Text":"FooterDown_Text__AUz3z"};